import React from 'react'

const ServiceDetailsWeb = () => {
  return (
    <div>ServiceDetailsWeb</div>
  )
}

export default ServiceDetailsWeb